import type {GetTeamCreditsResponse} from '@Libraries/user.library';
import {getTeamCreditsForUser} from '@Libraries/user.library';
import {updateTeamCredits} from '@Components/team-credits/team-credits-slice';

export const refreshTeamCreditsInStore = async (): Promise<GetTeamCreditsResponse> => {
  const response = await getTeamCreditsForUser();
  window.PMW.redux.store.dispatch(updateTeamCredits(response));
  return response;
};

export const getTeamCredits = async (): Promise<GetTeamCreditsResponse> => {
  const storeState = window.PMW.redux.store.getState().teamCredits;

  if (storeState.credits !== null) {
    return {
      credits: storeState.credits,
      freeCredits: storeState.freeCredits,
      freeCreditsExpiryDate: storeState.freeCreditsExpiryDate,
      legacyCredits: storeState.legacyCredits,
      legacyCreditsExpiryDate: storeState.legacyCreditsExpiryDate,
      purchasedCredits: storeState.purchasedCredits,
    };
  }

  return refreshTeamCreditsInStore();
};
